export default __webpack_public_path__ + "static/media/videocall.30b8fa3f.svg";